var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmailColor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0016 11.5086C16.0016 13.7097 14.2343 15.4928 12.0332 15.5006H12.0253H4.20683C2.01356 15.5006 0.222656 13.7255 0.222656 11.5244V11.5165C0.222656 11.5165 0.22739 8.0246 0.233701 6.26841C0.23449 5.93863 0.613184 5.75401 0.871169 5.95914C2.7457 7.4463 6.09793 10.1579 6.13974 10.1934C6.69989 10.6423 7.40995 10.8956 8.13577 10.8956C8.8616 10.8956 9.57166 10.6423 10.1318 10.1847C10.1736 10.1571 13.4509 7.52677 15.3538 6.01516C15.6126 5.80924 15.9929 5.99385 15.9937 6.32284C16.0016 8.06562 16.0016 11.5086 16.0016 11.5086Z",
    fill: "#1080FF",
    fillOpacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5897 3.40847C14.9065 2.12091 13.5621 1.29883 12.0821 1.29883H4.20839C2.72833 1.29883 1.38397 2.12091 0.700741 3.40847C0.547686 3.69643 0.620268 4.0554 0.875098 4.25895L6.73301 8.94449C7.14327 9.27585 7.6403 9.44074 8.13734 9.44074C8.14049 9.44074 8.14286 9.44074 8.14523 9.44074C8.14759 9.44074 8.15075 9.44074 8.15312 9.44074C8.65015 9.44074 9.14719 9.27585 9.55744 8.94449L15.4154 4.25895C15.6702 4.0554 15.7428 3.69643 15.5897 3.40847Z",
    fill: "#1080FF",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailColor);
export default __webpack_public_path__ + "static/media/email_color.8e18847ae5e4e9d2f07f951f04de3ad9.svg";
export { ForwardRef as ReactComponent };